export function AppLoader() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-background">
      <div className="relative flex items-center justify-center">
        <div className="absolute h-16 w-16 animate-ping rounded-full bg-primary/10" />
        <div className="relative h-12 w-12 animate-spin rounded-xl border-[3px] border-muted border-t-primary" />
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <p className="text-sm font-medium tracking-wide text-foreground">
          Cargando
        </p>
        <div className="flex gap-1">
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary [animation-delay:-0.3s]" />
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary [animation-delay:-0.15s]" />
          <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary" />
        </div>
      </div>
    </div>
  );
}
